import store from '~/store'

export default {
    LEVEL_MANAGER: 'manager',
    LEVEL_WRITE: 'write',
    LEVEL_READ: 'read',

    getLevels() {
        return [
            {value: this.LEVEL_READ,    text: 'Read Only'},
            {value: this.LEVEL_WRITE,   text: 'Editor'},
            {value: this.LEVEL_MANAGER, text: 'Manager'},
        ];
    },

    isSuperAdmin() {
        store.dispatch('auth/fetchUser');
        var user = store.getters['auth/user'];
        if (user != null) {
            return user.isAdmin;
        }
        return false;
    },

    isLoggedIn() {
        store.dispatch('auth/fetchUser');
        return store.getters['auth/check'];
    },

    isOrgManager(orgId) {
        store.dispatch('auth/fetchUser');
        if (this.isSuperAdmin()) {
            return true;
        } else {
            // orgId is optional.  If not supplied, we'll return true if the
            // user is the manager of at least one org.  Used for org list.
            if (typeof orgId != 'undefined') {
                var orgs = store.getters['auth/orgs'];
                var hasAccess = orgs.some(org => org.orgId == orgId);
                return hasAccess;
            } else {
                return store.getters['auth/hasOrgs'];
            }
        }
    },

    hasBuildingAccess(buildingId, requiredLevel) {
        store.dispatch('auth/fetchUser');
        if (this.isSuperAdmin()) {
            return true;
        } else {
            var userAccess = this._getBuildingAccess(buildingId)
            return this._hasMinimumAccess(userAccess, requiredLevel)
        }
    },

    _getBuildingAccess(buildingId) {
        var buildings = store.getters['auth/buildings']
        var building = buildings.find(el => el.buildingId == buildingId)
        if (typeof building != 'undefined') {
            return building.level
        }
        return null
    },


    _hasMinimumAccess(userLevel, requiredLevel) {
        var granted = false;
        if (requiredLevel == this.LEVEL_READ) {
            granted = [
                this.LEVEL_READ,
                this.LEVEL_WRITE,
                this.LEVEL_MANAGER,
            ].some(el => el == userLevel)
        } else {
            if (requiredLevel == this.LEVEL_WRITE) {
                granted = [
                    this.LEVEL_WRITE,
                    this.LEVEL_MANAGER,
                ].some(el => el == userLevel)
            } else {
                if (requiredLevel == this.LEVEL_MANAGER) {
                    granted = (userLevel == this.LEVEL_MANAGER);
                }
            }
        }

        return granted;
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/userauth.js